import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {

  constructor(
    private api: ApiService,
    private router: Router
  ) {
  }

  canActivate(): boolean {
    if (!this.api.isAdmin) this.router.navigate(['forbidden']);
    return this.api.isAdmin;
  }

}
